'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './workorder-ticket-show.routes';

export class WorkorderTicketShowComponent {
  constructor($state, $stateParams, dialogs, WorkOrderTicketsService, $uibModal, $window, Auth, RecentVisits, PinnedItems,
              $timeout) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.Auth = Auth;
    this.ticketId = $stateParams.id;
    this.prompt = prompt;
    this.$uibModal = $uibModal;
    this.tasks = [];
    this.activities = [];
    this.$timeout = $timeout;

    this.dialogs = dialogs;
    this.WorkOrderTicketsService = WorkOrderTicketsService;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    this.$state = $state;

    this.hook = {
      openSendAttachmentModal: this.openSendAttachmentModal.bind(this)
    };

    this.refreshData();
  }

  refreshAttachments() {
    let count = this.ticket.attachments.length;

    /* Nice Code :) */
    this.$timeout(_=> {
      this.refreshData(_=>{
        if (this.ticket.attachments.length === count) {
          this.$timeout(_=> {
            this.refreshData(_=>{
              if (this.ticket.attachments.length === count) {
                this.$timeout(_=> {
                  this.refreshData(_=>{
                    if (this.ticket.attachments.length === count) {
                      this.$timeout(_=> {
                        this.refreshData();
                      }, 10000);
                    }
                  });
                }, 5000);
              }
            });
          }, 2500);
        }
      });
    }, 2500);
  };

  refreshData() {
    if (this.ticketId) {
      this.WorkOrderTicketsService.get({id: this.ticketId}, data => {
        this.ticket = data;

        this.RecentVisits.addWorkItem(this.ticketId, "wo", `${this.ticket.code}: ${this.ticket.name}`);
        this.isPinned = this.PinnedItems.isPinnedWorkItem(this.ticketId);
      }, err => {
        console.log('Could not load work order ticket from server');
      });
    }
  }

  addToAttachments(id) {
    this.WorkOrderTicketsService.createPDFAndAttach({id}, _ => {
      this.refreshData();
    });
  }

  getEmails() {
    let emails = [];

    if (this.ticket.issuedTo) {
      this.ticket.issuedTo.email.forEach(email => {
        let group = this.ticket.issuedTo.name + " (Vendor)";

        let description = email.address + " (" + email.type + ")";

        if (email.isPrimary) {
          description += " (PRIMARY)"
        }

        emails.push({
          group: group,
          email: email.address,
          description: description
        })
      })
    }

    this.ticket.property.contacts.forEach(entry => {
      if (!entry.contact || typeof entry.contact !== 'object')
        return;

      entry.contact.email.forEach(email => {
        let group = entry.contact.firstName + " " + entry.contact.lastName + " (" + entry.type.replace("-", " ").toUpperCase() + ")";

        let description = email.address + " (" + email.type + ")";

        if (email.isPrimary) {
          description += " (PRIMARY)"
        }

        emails.push({
          group: group,
          email: email.address,
          description: description
        })
      })
    });

    return emails;
  }

  openSendAttachmentModal(attachment) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'sendAttachmentEmail',
      resolve: {
        config: function() {
          return {
            //email: 'hunzkunz@lorem.net',
            attachment: (attachment) ? attachment._id : null,
            attachments: that.ticket.attachments.filter(attachment => attachment.contentType !== 'text/html'),
            emails: that.getEmails(),
            templates: (that.ticket.mailBodyTemplate) ? [{
              level: "Template",
              mailSubjectTemplate: that.ticket.mailSubjectTemplate,
              mailBodyTemplate: that.ticket.mailBodyTemplate
            }]: [],
            contextVars: {
              ASSOCIATION_NAME: that.ticket.property.community.name,
              WORK_ORDER: that.ticket.code + ': ' + that.ticket.name,
              DESCRIPTION: (that.ticket.description) ? that.ticket.description.split(/\n/).join("<br/>") : '',
              INSTRUCTIONS: (that.ticket.instructions) ? that.ticket.instructions.split(/\n/).join("<br/>") : '',
              ENTITY_LINK: `<a target='_blank' href='http://192.168.178.47:3000/workorder/ticket/detail/${that.ticket._id}'>Open Work Order in Management Suite</a>`
            }
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (mail) {

        //TODO: delete !!!!!
        //mail.email = "h.muenzel@iba-tech.de";

        that.WorkOrderTicketsService.sendAttachmentMail({id: that.ticketId}, mail, _ => {
          that.refreshData();
        }, err => { console.log(err) })
      },
      function () { /* cancel */ }
    );

  }

  changeState() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'stateChangeForm',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (stateChange) {
        that.ticket.status = stateChange.status;

        if (stateChange.reason) {
          that.ticket.notes.push({
            meta: {
              creationUser: that.Auth.getCurrentUserSync()._id
            },
            note: "Changed the state to '" + stateChange.status + "' because: " + stateChange.reason
          })
        }

        if (stateChange.status == 'open') { // it was closed
          delete that.ticket.closeDate;     // then remove close date
        } else {
          that.ticket.closeDate = new Date(); // otherwise now it is closed
        }

        that.WorkOrderTicketsService.update({id: that.ticketId}, that.ticket, _ => that.refreshData());
      },
      function () { /* cancel */ }
    );

  }



  changeTargetDate() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'targetDateChangeForm',
      resolve: {
        config: function() {
          return {
            data: that.ticket
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (change) {
        that.ticket.targetDate = change.targetDate;

        if (change.note) {
          that.ticket.notes.push({
            meta: {
              creationUser: that.Auth.getCurrentUserSync()._id
            },
            note: change.note
          })
        }

        that.WorkOrderTicketsService.update({id: that.ticketId}, that.ticket, _ => that.refreshData());
      },
      function () { /* cancel */ }
    );

  }

  changeIssuedTo() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'issuedToChangeForm',
      resolve: {
        config: function() {
          return {
            data: that.ticket
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (change) {
        that.ticket.issuedTo = change.issuedTo;

        if (change.note) {
          that.ticket.notes.push({
            meta: {
              creationUser: that.Auth.getCurrentUserSync()._id
            },
            note: change.note
          })
        }

        that.WorkOrderTicketsService.update({id: that.ticketId}, that.ticket, _ => that.refreshData());
      },
      function () { /* cancel */ }
    );

  }

  approve() {
    var dlg = this.dialogs.confirm("Approve Work Order?", "Do you want to approve this work order?");
    dlg.result.then(() => {
      this.ticket.approvedBy = this.Auth.getCurrentUserSync()._id;
      this.WorkOrderTicketsService.update({id: this.ticketId}, this.ticket, _ => this.refreshData());
    },() => {
    });
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.WorkOrderTicketsService.addAttachments({id: that.ticketId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to ticket');
        });
      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.workOrderTicketShow', [uiRouter])
  .config(routes)
  .component('workOrderTicketShow', {
    template: require('./workorder-ticket-show.html'),
    controller: WorkorderTicketShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/workorders/ticket-show/workorder-ticket-show.component.js